import { useTranslation } from 'react-i18next';

type TranslationTextProps = {
  translationKey: string;
  placeholders?: Record<string, string | null | undefined>;
};

const TranslationText = ({
  translationKey,
  placeholders,
}: TranslationTextProps) => {
  const { t } = useTranslation();

  const translation = t(translationKey, placeholders);

  if (translation === translationKey.split(':::').pop()) {
    return null;
  }

  return translation;
};

export default TranslationText;
